// INFO: API (s=offer-detail-pois) returns POIs only within a 3 km radius, so we do not offer distances we have no data for
export const POI_DISTANCE_VALUES = [1, 3];

export const POI_DISTANCE_DEFAULT_VALUE = 1;
export const POI_DISTANCE_DEFAULT_VALUE_IN_METERS = POI_DISTANCE_DEFAULT_VALUE * 1000;

export const poiDistanceSelectOptions = POI_DISTANCE_VALUES.map((value) => ({
    value,
    label: `+${value} km`
}));
// INFO: API (s=offer-detail-pois) returns POIs only within a 3 km radius, so we do not offer distances we have no data for
export const POI_DISTANCE_VALUES = [1, 3];

export const POI_DISTANCE_DEFAULT_VALUE = 1;
export const POI_DISTANCE_DEFAULT_VALUE_IN_METERS = POI_DISTANCE_DEFAULT_VALUE * 1000;

export const poiDistanceSelectOptions = POI_DISTANCE_VALUES.map((value) => ({
    value,
    label: `+${value} km`
}));
